import { ButtonHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { IconName, SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';
import { theme } from '../../../styles/theme';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip: ReactNode;
  name: IconName;
  isActive?: boolean;
}

const StyledAction = styled.button<{ $isActive?: boolean }>`
  flex: 0 0 auto;
  display: flex;
  width: 24px;
  height: 24px;
  border: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  color: inherit;
  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const MenuBarButton = ({
  isActive,
  disabled,
  name,
  tooltip,
  ...props
}: IProps) => (
  <KubitTooltip content={tooltip} placement="top">
    <StyledAction type="button" disabled={disabled} {...props}>
      <SvgIcon
        name={name}
        isActive={isActive}
        isDisabled={disabled}
        customFill="currentColor"
      />
    </StyledAction>
  </KubitTooltip>
);

export default MenuBarButton;
